import { runInAction } from 'mobx';
import { createFetchedData } from '../../../../../utils/fetched-data/create-fetched-data';
import { getCacheDuration } from '../../../../../utils/get-cache-duration';
import { getMemberPaymentCards } from '../../../selectors/member/payment-cards/get-member-payment-cards';
import { temporaryLoyaltyDomainStore } from '../../../temporary-store/store';
export const addMemberPaymentCard = async (card) => {
    var _a;
    const memberPaymentCards = (_a = getMemberPaymentCards()) !== null && _a !== void 0 ? _a : [];
    runInAction(() => {
        temporaryLoyaltyDomainStore.data.memberPaymentCards = createFetchedData([...memberPaymentCards, card], getCacheDuration('member'));
    });
};
